#import "@/apollo/fragments/Campaign.gql"
#import "@/apollo/fragments/MasterTemplate.gql"

mutation UpdateTemplate($zipUrl: String!, $masterTemplateId: ID!, $force: Boolean, $type: TemplateType, $jobId: ID) {
    updateMasterTemplate(
        temporaryBucketZipPath: $zipUrl
        masterTemplateId: $masterTemplateId
        force: $force
        type: $type
        jobId: $jobId
    ) {
        jobId
        usedInCampaigns {
            ...Campaign
        }
        manifestHashChanged
        producedAds {
            published
            unpublished
        }
        editableGroupConflicts {
            added
            removed
        }
        templateFamily {
            ...MasterTemplate
        }
    }
}
